import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { OnboardingModalType } from "../onboarding/onboarding.component";
import { GameStateService } from "../../../../services/game-state/game-state.service";
import { SPINE_KEYS } from "../../../../constants/textures";
import { Container, Graphics } from "pixi.js";

@Component({
  selector: 'app-how-to-play',
  templateUrl: './how-to-play.component.html',
  styleUrl: './how-to-play.component.scss'
})
export class HowToPlayComponent implements AfterViewInit , OnDestroy{
  @Input()
  modalType: OnboardingModalType;
  @Output()
  close: EventEmitter<void> = new EventEmitter();

  overlay:Graphics;
  prevz;
  constructor(
    private cdr: ChangeDetectorRef,
    private state: GameStateService
  ) {}

  ngAfterViewInit(): void {

    // this.addOverlayToField(this.state.containers.mainField);
    // const mim = this.state.resourses.getSpine('mim');
    // this.prevz = mim?.zIndex;
    // if (mim)
    // mim.zIndex = 1001;
  }

  ngOnDestroy(): void {
    // this.state.containers.mainField.removeChild(this.overlay);
    // const mim = this.state.resourses.getSpine('mim');
    // if (mim)
    // mim.zIndex = this.prevz;
  }

  private addOverlayToField(field: Container) {
    this.overlay = new Graphics();

    this.overlay
      .rect(0, 0, field.width, field.height)
      .fill({
        color: 0x000000,
        alpha: 0.6,
      });

    this.overlay.zIndex = 1000;

    field.addChild(this.overlay);

  }

}